import { VERTRAEGE_UPGRADEN } from '@/domain/vertraege/shared/hooks/graphql/mutations';
import {
  Vertraege_UpgradenMutation,
  Vertraege_UpgradenMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

export function useVertraegeUpgraden() {
  const [execute, result] = useMutation<
    Vertraege_UpgradenMutation,
    Vertraege_UpgradenMutationVariables
  >(VERTRAEGE_UPGRADEN, {
    refetchQueries: ['GetBenachrichtigungen'],
  });

  const vertrageUpgraden = useCallback(
    (variables: Vertraege_UpgradenMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );
  return [vertrageUpgraden, result] as const;
}
